// extracted by mini-css-extract-plugin
export default {"FullScreenComposeEditorPane":"FullScreenComposeEditorPane_FullScreenComposeEditorPane__eDVl0","CloseEditorPaneButton":"FullScreenComposeEditorPane_CloseEditorPaneButton__e8NO1"};